export const socials = {
    title: 'Социальные сети',
    detach: 'Отвязать',
    detach_success: 'Социальная сеть отвязана',
    detach_text: 'Удалить привязку профиля социальной сети?'
};
